import http from './http';

const apiVersion = 'v1';
const uploadUrl = `/${apiVersion}/images/upload`;

const uploadFile = async (
	file: File | string,
	required = true,
	minWidth?: number,
	minHeight?: number,
	minShortestSide?: number,
	minLongestSide?: number,
	removeBackground = false,
	crop = false,
	logoSquare?: boolean,
) => {
	const formData = new FormData();
	if (file instanceof File) {
		formData.append('image_file', file);
	} else if (typeof file === 'string' && file.trim() !== '') {
		formData.append('image_url', file);
	} else {
		// If neither a File nor a valid string, throw an error
		throw new Error('Invalid file parameter: must be a File object or a non-empty string URL');
	}

	const params = new URLSearchParams();
	params.append('required', String(required));
	params.append('removeBackground', String(removeBackground));
	params.append('crop', String(crop));
	if (minWidth !== undefined) {
		params.append('minWidth', String(minWidth));
	}
	if (minHeight !== undefined) {
		params.append('minHeight', String(minHeight));
	}
	if (minShortestSide !== undefined) {
		params.append('minShortestSide', String(minShortestSide));
	}
	if (minLongestSide !== undefined) {
		params.append('minLongestSide', String(minLongestSide));
	}
	if (logoSquare) {
		params.append('generateSquareLogo', String(logoSquare));
	}

	const fullUrl = `${uploadUrl}?${params.toString()}`;
	try {
		const { data } = await http.post(
			fullUrl,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			},
		);
		return data;
	} catch (error: any) {
		console.error('Upload request failed:', error);
		throw error;
	}
};

export { uploadFile };
